import { Outlet } from "react-router";

import { TableColumnSettingsProvider } from "@providers/TableColumnSettingsProvider/TableColumnSettingsProvider";

import { ClientsCard } from "@components/Cards";
import { DEFAULT_CLIENT_TABLE_COLUMN_SETTINGS } from "@components/Tables/ClientsTable/UI/ClientsTableColumns";

export const Clients = () => {
  return (
    <TableColumnSettingsProvider
      tableId="clients"
      defaultColumnSettings={DEFAULT_CLIENT_TABLE_COLUMN_SETTINGS}
    >
      <ClientsCard />
      <Outlet />
    </TableColumnSettingsProvider>
  );
};
